import React, { useState } from "react";
import { Dimensions } from "react-native";
import InputSpinner from "react-native-input-spinner";
const { width, height } = Dimensions.get("window");

export default function inputSpinner({ event, setValue, max }) {
  const handleChange = (e) => {
    setValue(e);
  };
  return (
    <InputSpinner
      max={max}
      min={0}
      step={1}
      showBorder={1}
      rounded={false}
      textColor="#2B6AB1"
      buttonTextColor="#2B6AB1"
      fontFamily="Prompt"
      width={70}
      height={18}
      style={{
        marginHorizontal: event ? width * 0.035 : 26,
        borderColor: "#707070",
        marginTop: 12,
      }}
      inputStyle={{
        height: 18,
        borderWidth: 0,
        borderLeftWidth: 0.5,
        borderRightWidth: 0.5,
        borderColor: "#707070",
      }}
      buttonStyle={{
        width: 20,
        height: 18,
        backgroundColor: "#FFFFFF",
        color: "#2B6AB1",
      }}
      buttonFontSize={14}
      onChange={handleChange}
    />
  );
}
